// extracted by mini-css-extract-plugin
export default {"container":"E--z","productName":"F--z","price":"G--z","dimensions":"H--z"};